import { useEffect, useState, useCallback } from "react";
import { useSelector } from "react-redux";

import { getApi } from "../../api/api";
import { selectCurrentUser } from "../../store/slices/currentUserSlice";

interface MyCluster {
  id: number;
  name: string;
  domain: string;
}

export const useProfile = () => {
  const currentUser = useSelector(selectCurrentUser);

  const [myClusters, setMyClusters] = useState<MyCluster[]>([]);
  const [loading, setLoading] = useState(true);

  const loadClusters = useCallback(async () => {
    setLoading(true);
    try {
      const clusters = await getApi().getUserClusters();
      setMyClusters(clusters);
    } catch {
      setMyClusters([]);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    loadClusters();
  }, [loadClusters]);

  const displayName =
    currentUser?.email || currentUser?.phone_number || "Пользователь";

  return {
    currentUser,
    displayName,
    myClusters,
    loading,
    ready: !loading,
    isEmpty: myClusters.length === 0,
  };
};
